$(document)
  .ready(function () {
    // Split letters into span for animation purposes
    $('.strip').each(function (i, e) {
      let $t = $(this)
      let $target = $(this).data('target')
      let rows = $.trim($t.html()).split('<br>')
      $t.html('')

      $.each(rows, function (i, val) {
        $('<span class="row"></span>').appendTo($t)

        const letters = $.trim(val).split('')

        $.each(letters, function (j, v) {
          v = (v == ' ') ? '&nbsp;' : v
          $('<span class="letter-' + $target + '">' + $.trim(v) + '</span>').appendTo($('.row:last', $t))
        })
      })
    })

    // Init ScrollMagic
    const controller = new ScrollMagic.Controller()

    // pin the intro
    const fixIntroText = new ScrollMagic.Scene({
      triggerElement: '.first-scene',
      triggerHook: 0,
      duration: '100%'
    })
      .setClassToggle('.pinned-p', 'fixed')
      .addTo(controller)

    window.setTimeout(() => {
      $('.letter-intro').each((i, e) => {
        window.setTimeout(() => {
          const animateLetter = new ScrollMagic.Scene({
            triggerElement: '.first-scene',
            triggerHook: 0,
            duration: '100%'
          })
            .setClassToggle(e, 'animate')
            .addTo(controller)
        }, i * 20)
      })
    }, 4500)
    window.setTimeout(() => {
        $('.strip').addClass('hide-intro-message')
    }, 15000)
    // Reveal Transformation Message
    const revealTransformationMessage = new ScrollMagic.Scene({
      triggerElement: '.second-scene',
      triggerHook: 0.25
    })
      .setClassToggle('.teal-go-away', 'active')
      .addTo(controller)

    const removeTransformationMessage = new ScrollMagic.Scene({
      triggerElement: '.second-scene',
      triggerHook: 0.25
    })
      .setClassToggle('.transformation-message', 'hide-message')
      .addTo(controller)

    const initiateWorkGif = new ScrollMagic.Scene({
      triggerElement: '.second-scene',
      triggerHook: 0.25
    })
      .on('start', function () {
        window.setTimeout(function () {
          $('.video-player source').each(function () {
            const video = this.parentElement
            video.load()
            video.play()

            video.poster = '/assets/img/promo-bw-op2.gif'
          })
        }, 3500)
      })
      .addTo(controller)

    // Reveal Work Message
    $('.letter-work').each((i, e) => {
      const revealWorkMessage = new ScrollMagic.Scene({
        triggerElement: '.third-scene',
        triggerHook: 0.75,
        duration: '100%'
      })
        .on('start', function () {
          window.setTimeout(() => {
            if ($(e).hasClass('animate') !== true) {
              $(e).addClass('animate')
            }
          }, i * 20)
        })
        .addTo(controller)
    })

    const revealWorkLink = new ScrollMagic.Scene({
      triggerElement: '.third-scene',
      triggerHook: 0.75,
      duration: '100%'
    })
      .on('start', () => {
        window.setTimeout(() => {
          if ($('[data-jumpto="work"]').hasClass('animated') !== true) {
            $('[data-jumpto="work"]').addClass('animated')
          }
        }, 3000)
      })
      .addTo(controller)

    const animateFooterLogo = new ScrollMagic.Scene({
      triggerElement: '#contact',
      triggerHook: 0.9,
      reverse: false
    })
      .on('start', function () {
        window.setTimeout(function () {
          var lineDrawing = anime({
            targets: '#lineDrawing path, #lineDrawing polygon',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1500,
            // delay: function (el, i) { return i * 250 },
            direction: 'forward',
            loop: false,
            complete: function (anim) {
              $('#lineDrawing path, #lineDrawing polygon').css('transition', 'fill .5s ease').css('fill', '#1A1919')
            }
          });
        }, 1000)
      })
      .addTo(controller)

    // Pause Vimeo on modal close

    function stopVideo() {
      var $frame = $('iframe#vimeo-iframe')
      // saves the current iframe source
      var vidsrc = $frame.attr('src')
      // sets the source to nothing, stopping the video
      $frame.attr('src', '')
      // sets it back to the correct link so that it reloads immediately on the next window open
      $frame.attr('src', vidsrc)
    }

    $('#workVideoModal').on('hidden.bs.modal', function (e) {
      stopVideo()
    })

    // Close document ready callback.
  })



// WEBPACK FOOTER //
// ./src/assets/js/_scrollMagic.js